import {React,useEffect,useState} from 'react';
import { useHistory } from 'react-router-dom';
import { Container , Row } from 'react-bootstrap';
import api from '../../seller-apis/api';
import './login.css';
import { useAlert } from 'react-alert';

function Log(props) {
  let history = useHistory()
  let alert = useAlert();
  const [lmobile, setlmobile] = useState("");
  const [validMobile, setValidMobile] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

const [toast, settoast] = useState("none");
const [toastMsg, settoastMsg] = useState("");

useEffect(()=>{
  if(props.match.params.no){
    setlmobile(props.match.params.no)
  }
},[])

function checkMinusInput(e) {
  if (e.code === "Minus") {
      e.preventDefault();
  }
}
function checkPhoneValidation(event){
  setValidMobile(false);
  if(event.target.value.length==10){
    setValidMobile(true);
  }
}
function handleKeyPress(event){
  
  if (event.charCode === 13) {
    if (isLoggingIn) return;
    loginfun();
  }
}
  
  function loginfun() {
    if (isLoggingIn) return;

    settoast("none")
    if(lmobile){
      if(lmobile.length === 10){
        let data = {
          "phoneNumber":lmobile
        }
        setIsLoggingIn(true);
        api.auth.login(data).then((res)=>{
          console.log(res)
          if(res.message === "Otp Sent "){
            window.location.assign('/verification/'+lmobile);
           }
           else{
            if(res.message === "Seller Not Found"){
              window.location.assign('/');
            }
            settoastMsg(res.message)
            settoast("block")
          }
         }).catch((err)=>{
          const errorMessage = err?.response?.data?.message || err?.message;
          settoastMsg(errorMessage);
          settoast("block")
         }).finally(() => {
          setIsLoggingIn(false);
         })
        
       }
       else{
        settoastMsg("Please Enter Your Valid Mobile No");
        settoast("block")
       }
  
}
else{
  settoastMsg("Please Enter Your Valid Mobile No");
  settoast("block")
 }
  }



// -----------------------------FOR Desk-----------------------//
  return (


  
    <div className="p-0  pr welcome-C">


    <Container>
      <Row>
        <div className="col-lg-5 col-md-12 " >
      
    <div className="">
        
         <Container className="card card-div bg-theme "  style={{backgroundImage: `url("/login-icon/11.png")`}}>
         <div className="col-12 bg-theme text-center"><img src="/call.png" width="80px" alt="img"></img></div>
           {/* <p className="mb-0 mt-4 text-center fs-14 f-500 text-gray">Enter Your Mobile Number</p> */}
         <Row className="">
         {/* <div className="col-3">
           <div class="input-cont">
		
<label for="name" class="label-name ">
			<span class="content-name fs-13 f-600">
	 IN (+91) <span><i className="fa fa-angle-right"></i></span>
			</span>
	 	</label>
	 </div>
             </div> */}
            <div className="col-12">
            <div class="input-cont mt-4 px-5">
		<input type="number" name="Number" value={lmobile} autocomplete="off" onKeyDown={checkMinusInput} onChange={(e)=>{
      setlmobile(e.target.value); 
      checkPhoneValidation(e);}} onKeyPress={handleKeyPress} onWheel={(e)=>e.target.blur()} required className="bg-white corner1 py-1 px-3" />
                      <label for="name" class=" fs-14 label-name b-n">

                        <span class=" ">

                          <span class="content-name1 content-name ff_Futura"> IN (+91)Enter Your Mobile Number</span>
                        </span>

                      </label>

                    </div>
                    <div className='login-toast' style={{display:toast}}>
                      <span>{" " + toastMsg}</span>
                    </div>
                  </div>

                </Row>

                <div>
          <a>
            <button
              className={`b-n otp otp-desk ${validMobile ? "active-button" : ""} ${isLoggingIn ? "disabled" : ""}`}
              onClick={loginfun}
              disabled={isLoggingIn}
            >
              {isLoggingIn ? "Sending OTP..." : "Get OTP"}
            </button>
          </a>
          </div>
           </Container>
       
       </div>
   
    </div>
   
    <div className="col-lg-7 col-md-12 text-center ">
    <img src="/seller-logo.png"  alt="img" className="w-50" /><br></br>
    <img src="/login-icon/deliver.png" className="hand-bag mt-4"    alt="img" />
  
    </div>
    </Row>
    </Container>
  </div>

)



}




export default Log;